/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NotificationsInputs */

const en_nav_notifications = /** @type {(inputs: Nav_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails sent`)
};

/**
* | output |
* | --- |
* | "Emails sent" |
*
* @param {Nav_NotificationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_notifications = /** @type {((inputs?: Nav_NotificationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NotificationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_notifications(inputs)
});